import { Box, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import { isString } from 'lodash';
import moment from 'moment';
import KenTextLabel from '../KenTextLabel';
import KenIcon from '../KenIcon';
import ErrorIcon from '../../Assets/Icons/error.png';
import { makeStyles } from '@mui/styles';
import DoneIcon from '@mui/icons-material/Done';
import { useFormContext } from 'react-hook-form';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

const useStyles = makeStyles((theme) => ({
  errorStyles: {
    backgroundColor: '#ffffff',
  },
  successMessage: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#158467',
  },
  dateField: {
    height: 'auto',
    width: '100%',
    borderRadius: '8px',
    backgroundColor: '#fff',
    color: '#000',
    fontFamily: 'Poppins',
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      fontSize: '15px',
    },
    [theme.breakpoints.down('md')]: {
      '& .MuiOutlinedInput-root': {
        height: '40px',
      },
      '& .MuiFormLabel-root': {
        fontSize: '14px !important',
        margin: '-6px',
      },
    },
  },
}));

const KenDateField = (props) => {
  const {
    label,
    required,
    optionalLabel,
    error,
    ui,
    success,
    hideLabel = false,
    helperText,
    onError,
  } = props;
  const classes = useStyles();
  const { setValue } = useFormContext();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));

  const maxDate = moment().subtract(18, 'years').format('YYYY-MM-DD');
  const minDate = moment().subtract(100, 'years').format('YYYY-MM-DD'); // Adjust as necessary

  const validateDate = (date) => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    const isValid = moment(formattedDate).isSameOrBefore(maxDate);
    return isValid ? formattedDate : null;
  };

  return (
    <>
      <Box width="100%">
        <Box component={'div'} className="d-flex flex-column" gap={'12px'}>
          {!hideLabel && !isMobileScreen && (
            <KenTextLabel
              label={label}
              required={required}
              optionalLabel={optionalLabel}
              labelClassName={props.labelClassName}
              helperText={helperText}
            />
          )}
          <Box display="flex" alignItems="flex-start">
            <DesktopDatePicker
              className={classes.dateField}
              {...props}
              // slotProps={{
              //   textField: {
              //     onKeyDown: (e) => {
              //       props?.disableKeyDown && e.preventDefault();
              //     }
              //   }
              // }}
              onChange={(date) => {
                const validatedDate = validateDate(date);
                if (validatedDate) {
                  props.onChange(validatedDate); // Update value if valid
                } else {
                  onError && onError('Date must be 18 years or older'); // Trigger error callback
                  props.onChange(null); // Reset invalid value
                }
              }}
              label={isMobileScreen ? props?.label : null}
              maxDate={moment(maxDate)}
              minDate={moment(minDate)}
              value={props.value ? moment(props.value) : null}
            />
            {error && (
              <Box width="16px" height="16px" margin="19px 8px">
                <KenIcon
                  iconType="img"
                  icon={ErrorIcon}
                  variant="extraSmall"
                ></KenIcon>
              </Box>
            )}
          </Box>
        </Box>
        {success && (
          <Box display="flex" alignItems="flex-start" pt={1}>
            <Typography component="span">
              {success.icon || (
                <DoneIcon fontSize="small" style={{ color: '#158467' }} />
              )}
            </Typography>
            <Typography
              component="span"
              className={classes.successMessage}
              pl={1}
            >
              {success.message}
            </Typography>
          </Box>
        )}
      </Box>
      {error && (
        <Typography style={{ fontSize: 12, color: "red" }}>
          Age must be 18 and above
        </Typography>
      )}
      {ui && ui?.divider && (
        <Box mt={2} mb={2}>
          <Divider />
        </Box>
      )}
    </>
  );
};

export default KenDateField;
